module.exports = __webpack_public_path__ + "img/HorseShoe_TH.ade03c15.png";